<template>
    <div>
        <section>
            <div class="inner row5">
                <h1 class="boardTitle" v-if="getUser != null && getUser.roleName == 'ROLE_ADMIN'">FAQ 관리</h1>
                <h1 class="boardTitle" v-else>FAQ</h1>
                <div>
                    <div class="row4">
                        <div class="mobileReversePosition">
                            <div class="topContent flex">
                                <div class="left flex mobileReset">
                                    <p>총 <span>{{ totalCnt }}</span>건</p>
                                    <p>현재 페이지 {{ currentPage }} / {{ totalPage }}</p>
                                </div>
                                <div class="flex mWd100">
                                    <Search />
                                    <div class="btnBox blankLeft inlineB" v-if="getUser != null && getUser.roleName == 'ROLE_ADMIN'">
                                        <button class="greenBtn smBtn" type="button" @click="writeBtn()">등록</button>
                                        <button class="orangeBtn smBtn" type="button" @click="deleteBtn()">삭제</button>
                                    </div>
                                </div>
                            </div>
                            <div class="noticeBox" v-if="getUser == null || getUser.roleName != 'ROLE_ADMIN'">
                                <div class="borderBox">
                                    <p>
                                        FAQ 검색을 이용하시면 궁금하신 내용을 보다 빠르고 편리하게 찾으실 수 있습니다. <br>
                                        궁금증이 해결되지 않으면 로그인 후 1:1 문의를 이용해 주세요.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="mobileBlock totalCount">
                            <p>총 <span class="colorRed">{{ totalCnt }}</span>건</p>
                        </div>
                        <div class="noticeBoard faqBoard">
                            <FaqList ref="board"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
    </div>   
</template>

<script>
import axios from '@/axios/axios'
import FaqList from '@/components/layout/board/FaqList'
import Search from '@/components/layout/board/Search'
import { mapGetters, mapState } from 'vuex'

export default {
    name: 'FAQ',
    components: {
        FaqList,
        Search
    },
    computed: {
        ...mapGetters('auth', [
            'getUser'
        ]),
        ...mapState("board", ["perPage", "currentPage", "totalCnt"]),
        totalPage(){
            let totalCnt = this.$store.state.board.totalCnt;
            let perPage = this.$store.state.board.perPage;
            
            if (totalCnt == 0) return 1;
            else if(totalCnt % perPage == 0) return totalCnt/perPage;
			else return Math.floor(totalCnt/perPage) + 1;
		}
    },
    data () {
        return {
            fields:  [
                {
                    key: 'ROWNUM',
                    label: 'NO.',
                    sortable: false
                },
                {
                    key: 'QUESTION',
                    label: '제목',
                    sortable: false
                }
            ]
        }
    },
    methods:{
        setFaq(){
            if(this.$store.state.auth.user != null && this.$store.state.auth.user.roleName == "ROLE_ADMIN"){
                this.fields = [
                    {
                        key: 'selected',
                        label: '선택',
                        class: 'text-center',
                    },
                    {
                        key: 'ROWNUM',
                        label: 'NO.',
                        sortable: false,
                    },
                    {
                        key: 'QUESTION',
                        label: '제목',
                        sortable: false
                    },
                    {
                        key: 'REGDATE',
                        label: '등록일',
                        sortable: false
                    }
                ]
            }

            let boarObj = {
                getListURL: "/api/faq/getList",
                currentPage: 1,
                perPage: 10,
                sortBy: 'IDX',
                sortDesc: false,
                searchText : "",
                routerName : "fAQManagementDetail",
                url : "/FAQ",
                fields: this.fields
            };
            
            this.$store.dispatch('board/setBoardSetting', boarObj);
        },
        writeBtn(){
            this.$router.push({ path :'/admin/fAQManagementWrite'});
        },
        deleteBtn(){
            let selected = this.$refs.board.selected;
            if(selected.length == 0){
                this.$alert("알림", "삭제할 글을 선택해주세요.");
                return false;
            }
            
            var response = this.$createConfirmResponse()
            this.$confirm("알림", `${selected.length}개 항목을 삭제하시겠습니까?`, "확인", "취소", response, {
                'closed': () => {
                    if(response.result){
                        let paramDatas = { list : selected };
                        axios.post('/api/admin/faq/delete', paramDatas)
                        .then(result => {
                            if(result.status == 200){
                                this.$alert("알림", "FAQ글이 삭제되었습니다.", "", {
                                    'closed': () => {
                                        this.$refs.board.$refs.table1.refresh();
                                        this.$refs.board.$refs.table2.refresh();
                                    }
                                });
                            }
                            else {
                                this.$alert("알림", "FAQ글 삭제에 실패하였습니다.");
                            }
                        })
                        .catch((error) => {
                            this.$alert("알림", "FAQ 삭제실패하였습니다. <br>", error.response.data);
                        });
                    }
                }
            });
        }

    },
    created(){
        this.setFaq();
    },
}

</script>

<style scoped>
    a {
        color: #272727;
    }
    h3 {
        margin: 0 0 16px 0;
    }
    .tableContainer .sampleTemplate .mb-2 {
        margin-bottom: 0 !important;
    }
</style>

<style scoped lang="scss">
    .sampleTemplate ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
        @import "~bootstrap-vue/dist/bootstrap-vue.min";
    }
    .faqBoard .sampleTemplate .table-hover > tbody > tr:hover {
        background: transparent;
        --bs-table-accent-bg: transparent;
    }
</style>